import { whyUseItems } from "@/mocks/home";

export default function WhyUseSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-2/5 flex-shrink-0">
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4">
              Verified Guide
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
              Why Use<br />
              <span className="text-primary-500">Superbuy Spreadsheet?</span>
            </h2>
            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-md">
              A well-maintained Superbuy spreadsheet gives you access to hundreds of verified product links,
              trusted seller ratings, and community-vetted resources. Skip the guesswork and buy with confidence
              using the most comprehensive international shopping guide available.
            </p>
            <a
              href="#safety"
              className="inline-flex items-center gap-2 mt-6 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer"
            >
              Read Safety Guide
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>

          <div className="lg:w-3/5 relative">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {whyUseItems.map((item) => (
                <div
                  key={item.title}
                  className="bg-background-100 rounded-lg p-5 md:p-6"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className={`${item.icon} text-lg text-accent-600`}></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}